import * as _ from "lodash";

export const getValue = (object: any, path: any, defaultValue: any = null) =>
  _.get(object, path, defaultValue) || defaultValue;

export const getKeyFromValue = (object: any, value: string) => {
  return Object.keys(object).find((key) => object[key] === value);
};

export const isEmpty = (value: object) => _.isEmpty(value);
